<h2 *ngIf="data.type === 'SMS'" mat-dialog-title>Enviar Linha Digitavel Via SMS</h2>

<h2 *ngIf="data.type === 'EMAIL'" mat-dialog-title>Enviar Linha Digitavel Via EMAIL</h2>

<mat-dialog-content class="mat-typography">
  <form #form="ngForm">
    <mat-form-field *ngIf="data.type === 'EMAIL'" class="fullwidth" appearance="outline">
      <mat-label>Email</mat-label>
      <input 
        matInput
        name="inputEmail"
        #inputEmail="ngModel"
        [(ngModel)]="usuario.email"
        placeholder="exemplo@exemplo.com" 
        autocomplete="off"
        disabled
        readonly
        type="email"
        required
        pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
        >
        <mat-icon matSuffix>email</mat-icon>
        <mat-error *ngIf="inputEmail.touched && inputEmail?.errors?.pattern">
          Email inválido
        </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="data.type === 'SMS'" class="fullwidth" appearance="outline">
      <mat-label>Telefone</mat-label>
      <input 
        matInput
        name="inputTelefone"
        #inputTelefone="ngModel"
        [(ngModel)]="usuario.telefone"
        mascara="(00) 00000-0000"
        placeholder="(00) 00000-0000" 
        autocomplete="off"
        required
        disabled
        readonly
        >
        <mat-icon matSuffix>call</mat-icon>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button 
    *ngIf="data.type === 'SMS'" 
    mat-raised-button 
    color="primary" 
    [disabled]="form.invalid"
    (click)="handleSubmit()"
    cdkFocusInitial>
    Enviar SMS
  </button>

  <button 
    *ngIf="data.type === 'EMAIL'" 
    mat-raised-button 
    color="primary" 
    [disabled]="form.invalid"
    (click)="handleSubmit()"
    cdkFocusInitial>
    Enviar Email
  </button>
</mat-dialog-actions>